module.exports = __webpack_public_path__ + "assets/img/world-map-banner.dcb5c87f.png";